import { render, staticRenderFns } from "./AGBPage.vue?vue&type=template&id=29e1376e&scoped=true&"
import script from "./AGBPage.vue?vue&type=script&lang=js&"
export * from "./AGBPage.vue?vue&type=script&lang=js&"
import style0 from "./AGBPage.vue?vue&type=style&index=0&id=29e1376e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e1376e",
  null
  
)

export default component.exports